import Controller from '@ember/controller';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class AccountsAccountController extends Controller {
  @service access;
  @service branchSettings;
  @service router;
  @service session;
  @service sidebar;
  @service swingBridge;

  get isEmbeddedInSwing() {
    return this.swingBridge.isEmbeddedInSwing;
  }

  get isSidebarOpen() {
    return this.sidebar.isOpen;
  }

  get padSidebar() {
    return !this.isEmbeddedInSwing && this.sidebar.isOpen;
  }

  get pageTitle() {
    let branchName = '';
    if (this.session.branch && this.session.branchList?.length > 1) {
      branchName = this.session.branch.shortName;
    }
    return branchName;
  }

  get appColor() {
    return this.branchSettings.appColor;
  }

  get isThemeColorDark() {
    return this.branchSettings.isThemeColorDark;
  }

  @action
  toggleSidebar() {
    this.sidebar.toggleSidebar();
  }

  @action
  validateActivePermissions() {
    // We skip showing PIN-pad on the internal print routes, so Electron is able to print receipts. Otherwise, a PIN-pad would be shown preventing Electron from printing.
    const isPrintViewRoute =
      this.router.currentRoute?.queryParams?.printView === 'true';

    if (
      this.session.isAuthenticated &&
      !isPrintViewRoute &&
      (!this.access.activePermissionsValid ||
        !this.session.currentUserHasAccessToCurrentAccount)
    ) {
      this.router.replaceWith('pin-pad');
    }
  }
}
